import React from "react";
import {
  Container,
  Grid,
  Box,
  IconButton,
  makeStyles,
  Typography,
  Link,
} from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

import { FiFacebook } from "react-icons/fi";
import { FaTelegramPlane } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FiTwitter } from "react-icons/fi";
import { FaMediumM } from "react-icons/fa";
import { useWeb3React } from "@web3-react/core";
const useStyles = makeStyles((theme) => ({
  divider: {
    borderTop: "1px solid #C5C5C5",
    paddingBottom: "20px",
  },
  socialicons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    "& svg": {
      color: "#7D7E7E",
      cursor: "pointer",
      fontSize: "19px",
      paddingLeft: "11px",
      [theme.breakpoints.down("sm")]: {
        paddingLeft: "0px",
      },
      "&:hover": {
        color: "#39A9F4",
      },
    },
  },
  linkbox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    flexWrap: "wrap",
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "& a": {
      color: "#959595",
      fontFamily: "Anybody",
      fontWeight: 600,
      fontSize: "13px",
      lineHeight: "30px",
      paddingRight: "20px",
      textDecoration: "none",
      "&:hover": {
        color: "#39A9F4",
      },
    },
  },
  logobox: {
    order: "4",
    "& h6": {
      color: "#959595",
      paddingTop: "15px",
      lineHeight: "30px",
      paddingLeft: "88px",
      [theme.breakpoints.down("sm")]: {
        paddingLeft: "0px",
      },
    },
  },
  linkgrid: {
    order: "0",
    [theme.breakpoints.down("sm")]: {
      order: "1",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  logogrid: {
    order: "1",
    [theme.breakpoints.down("sm")]: {
      order: "0",
    },
  },
  falsegrid: {
    order: "2",
  },
  socialgrid: {
    order: "3",
  },
}));
const Footersection = () => {
  const classes = useStyles();
  const { account } = useWeb3React();
  return (
    <Box pb={3}>
      <Container>
        <Box className={classes.divider}></Box>
        <Grid container spacing={2}>
          <Grid item lg={5} md={5} sm={12} xs={12} className={classes.linkgrid}>
            <Box className={classes.linkbox}>
              <RouterLink to="/">Home</RouterLink>
              {account && <RouterLink to="/dashboard">Dashboard</RouterLink>}
              <RouterLink to="/privacy">Privacy</RouterLink>
              <RouterLink to="/term">Terms and Conditions</RouterLink>
            </Box>
          </Grid>
          <Grid
            item
            lg={3}
            md={3}
            sm={12}
            xs={12}
            align="center"
            className={classes.logogrid}
          >
            <img src="images/logo.png" alt="logo" />
          </Grid>
          <Grid
            item
            lg={2}
            md={2}
            sm={4}
            xs={3}
            className={classes.falsegrid}
          ></Grid>
          <Grid item lg={2} md={2} sm={4} xs={6} className={classes.socialgrid}>
            <Box className={classes.socialicons}>
              <Link href="https://www.facebook.com/hovr.site/" target="_blank">
                <FiFacebook />
              </Link>

              <Link href="https://t.me/HovRonQiblockchain" target="_blank">
                <FaTelegramPlane />
              </Link>
              <Link
                href="https://www.instagram.com/hovr.site/?igshid=YmMyMTA2M2Y%3D"
                target="_blank"
              >
                <FaInstagram />
              </Link>
              <Link href="https://twitter.com/HovrSite" target="_blank">
                <FiTwitter />
              </Link>
              <Link href="https://www.reddit.com/r/hovrNFT/" target="_blank">
                <FaMediumM />
              </Link>
            </Box>
          </Grid>
        </Grid>
        <Box className={classes.logobox} align="center">
          <Typography variant="h6">
            Copyright © 2022 HOVR, ALL RIGHTS RESERVED
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footersection;
